export function generateArrayByLength(length: number): number[] {
  if (length <= 0) {
    throw new Error('The number of elements must be greater than zero.');
  }

  return Array.from({ length }, (_, index) => index);
}
